export default {
  background: '#4F5C72'
}